/**
 * Format mileage with thousands separators and optional unit.
 * @param {number|string} mileage - The mileage value (can be number or string).
 * @param {boolean} includeUnit - Whether to include "km" at the end (default: true).
 * @returns {string} - Formatted mileage string (e.g. "48,200 km").
 */
export const formatMileage = (mileage, includeUnit = true) => {
  if (mileage === null || mileage === undefined || mileage === "") return "-"

  // Convert to number
  const num = Number(mileage)
  if (isNaN(num)) return String(mileage)

  // Format with thousands separator
  const formatted = num.toLocaleString("en-US")

  return includeUnit ? `${formatted} km` : formatted
}

// Convert number to words function
export const convertToWords = num => {
  if (num === 0) return "Zero"

  const ones = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ]
  const tens = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ]

  let words = ""

  if (Math.floor(num / 10000000) > 0) {
    words += convertToWords(Math.floor(num / 10000000)) + " Crore "
    num %= 10000000
  }

  if (Math.floor(num / 100000) > 0) {
    words += convertToWords(Math.floor(num / 100000)) + " Lakh "
    num %= 100000
  }

  if (Math.floor(num / 1000) > 0) {
    words += convertToWords(Math.floor(num / 1000)) + " Thousand "
    num %= 1000
  }

  if (Math.floor(num / 100) > 0) {
    words += convertToWords(Math.floor(num / 100)) + " Hundred "
    num %= 100
  }

  if (num > 0) {
    if (words !== "") words += "and "

    if (num < 20) {
      words += ones[num]
    } else {
      words += tens[Math.floor(num / 10)]
      if (num % 10 > 0) {
        words += " " + ones[num % 10]
      }
    }
  }

  return words.trim()
}
